import { AnyObjectSchema } from 'yup'; // eslint-disable-line import/named
import { RowMessages } from './useEditableGridLogic';

export const validateBaseSchema = <TData, TLookUpData>(
  schema: AnyObjectSchema,
  value: TData,
  context: TLookUpData
): RowMessages<TData> => {
  try {
    schema.validateSync(value, {
      abortEarly: false,
      strict: true,
      context,
    });
    return {};
  } catch (error: any) {
    const errorObj = error.inner.reduce((
      acc: RowMessages<TData>,
      { errors, params }: {errors: string[], params: { path: keyof TData}}
    ) => {
      acc[params.path] = errors;
      return acc;
    }, {} as RowMessages<TData>);

    return {
      ...errorObj,
    };
  }
};
